import baseClass from "./base";
import generalTools from "./tools";
import customFormObj from "./form";

window.js_g_recaptcha_invisible_onsubmit = function (token) {
  const obj = $("#" + customFormObj.currentformid);
  obj.append('<input type="hidden" name="g-recaptcha-response" value="' + token + '" />');

  return customFormObj.submitForm(obj);
};

function checkrecaptchainvisible_obj(obj) {
  if (obj.hasClass("added")) return;
  obj.addClass("added");

  var id = obj.attr("id");
  if (id == undefined) {
    id = "id" + generalTools.uuidv4();
    obj.attr("id", id);
  }
  // -----------------
  var captchaWidgetId = grecaptcha.render(id, {
    sitekey: obj.attr("data-sitekey"),
  });
}

// ------------------------------------
baseClass.OnReadyArrAdd(function () {
  $(".js_g_recaptcha_invisible").each(function () {
    checkrecaptchainvisible_obj($(this));
  });
});

// ------------------------------------
